/** API route map: URLS.Controller.ClientBenefitsPlan */
export const ClientBenefitsPlan = {
      Name: 'ClientBenefitsPlan/',
      GetAll: 'getall',
      Add: 'add',
      Delete: 'delete',
      Update: 'update',
      UpdatePlanStatus: 'update-clientPlanStatus',
      GetBenefits: 'get-benefits',
      AddLibraryBenefits: 'add-library-benefits',
      GetBenefitsOverview: 'get-benefits-overview',
      ClientBenefitPlanTermination: 'client-benefit-plan-termination',
      ClientBenefitPlanAssociation: 'client-benefit-plan-association',
};
